import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
var UUID = 0;
var MAX_WORKERS;
var WHITE_PNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";
var checkImageBitmapCode = {
  id: "checkImageBitmap",
  code: "\n    async function checkImageBitmap()\n    {\n        try\n        {\n            if (typeof createImageBitmap !== 'function') return false;\n\n            const response = await fetch('".concat(WHITE_PNG, "');\n            const imageBlob =  await response.blob();\n            const imageBitmap = await createImageBitmap(imageBlob);\n\n            return imageBitmap.width === 1 && imageBitmap.height === 1;\n        }\n        catch (e)\n        {\n            return false;\n        }\n    }\n    checkImageBitmap().then((result) => { self.postMessage(result); });\n    ")
};
var workerCode = {
  id: "loadImageBitmap",
  code: "\n    async function loadImageBitmap(url)\n    {\n        const response = await fetch(url);\n\n        if (!response.ok)\n        {\n            throw new Error(`[WorkerManager.loadImageBitmap] Failed to fetch ${url}: `\n                + `${response.status} ${response.statusText}`);\n        }\n\n        const imageBlob =  await response.blob();\n        const imageBitmap = await createImageBitmap(imageBlob);\n\n        return imageBitmap;\n    }\n    self.onmessage = async (event) =>\n    {\n        try\n        {\n            const imageBitmap = await loadImageBitmap(event.data.data[0]);\n\n            self.postMessage({\n                data: imageBitmap,\n                uuid: event.data.uuid,\n                id: event.data.id,\n            }, [imageBitmap]);\n        }\n        catch(e)\n        {\n            self.postMessage({\n                error: e,\n                uuid: event.data.uuid,\n                id: event.data.id,\n            });\n        }\n    };"
};
var workerURL;
var WorkerManagerClass = /*#__PURE__*/function () {
  function WorkerManagerClass() {
    _classCallCheck(this, WorkerManagerClass);
    this._initialized = false;
    this._createdWorkers = 0;
    this.workerPool = [];
    this.queue = [];
    this.resolveHash = {};
  }
  _createClass(WorkerManagerClass, [{
    key: "isImageBitmapSupported",
    value: function isImageBitmapSupported() {
      if (this._isImageBitmapSupported !== void 0) return this._isImageBitmapSupported;
      this._isImageBitmapSupported = new Promise(function (resolve) {
        var workerURL2 = URL.createObjectURL(new Blob([checkImageBitmapCode.code], {
          type: "application/javascript"
        }));
        var worker = new Worker(workerURL2);
        worker.addEventListener("message", function (event) {
          worker.terminate();
          URL.revokeObjectURL(workerURL2);
          resolve(event.data);
        });
      });
      return this._isImageBitmapSupported;
    }
  }, {
    key: "loadImageBitmap",
    value: function loadImageBitmap(src) {
      return this._run("loadImageBitmap", [src]);
    }
  }, {
    key: "_initWorkers",
    value: function () {
      var _initWorkers2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this._initialized) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              this._initialized = true;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _initWorkers() {
        return _initWorkers2.apply(this, arguments);
      }
      return _initWorkers;
    }()
  }, {
    key: "getWorker",
    value: function getWorker() {
      var _this = this;
      if (MAX_WORKERS === void 0) {
        MAX_WORKERS = navigator.hardwareConcurrency || 4;
      }
      var worker = this.workerPool.pop();
      if (!worker && this._createdWorkers < MAX_WORKERS) {
        if (!workerURL) {
          workerURL = URL.createObjectURL(new Blob([workerCode.code], {
            type: "application/javascript"
          }));
        }
        this._createdWorkers++;
        worker = new Worker(workerURL);
        worker.addEventListener("message", function (event) {
          _this.complete(event.data);
          _this.returnWorker(event.target);
          _this.next();
        });
      }
      return worker;
    }
  }, {
    key: "returnWorker",
    value: function returnWorker(worker) {
      this.workerPool.push(worker);
    }
  }, {
    key: "complete",
    value: function complete(data) {
      if (data.error !== void 0) {
        this.resolveHash[data.uuid].reject(data.error);
      } else {
        this.resolveHash[data.uuid].resolve(data.data);
      }
      this.resolveHash[data.uuid] = null;
    }
  }, {
    key: "_run",
    value: function () {
      var _run2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, args) {
        var _this2 = this;
        var promise;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this._initWorkers();
            case 2:
              promise = new Promise(function (resolve, reject) {
                _this2.queue.push({
                  id: id,
                  arguments: args,
                  resolve: resolve,
                  reject: reject
                });
              });
              this.next();
              return _context2.abrupt("return", promise);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _run(_x, _x2) {
        return _run2.apply(this, arguments);
      }
      return _run;
    }()
  }, {
    key: "next",
    value: function next() {
      if (!this.queue.length) return;
      var worker = this.getWorker();
      if (!worker) {
        return;
      }
      var toDo = this.queue.pop();
      var id = toDo.id;
      this.resolveHash[UUID] = {
        resolve: toDo.resolve,
        reject: toDo.reject
      };
      worker.postMessage({
        data: toDo.arguments,
        uuid: UUID++,
        id: id
      });
    }
  }]);
  return WorkerManagerClass;
}();
var WorkerManager = new WorkerManagerClass();
export { WorkerManager };